import { render } from "./GaussianChart.vue?vue&type=template&id=5f07c2a0&scoped=true"
import script from "./GaussianChart.vue?vue&type=script&lang=js"
export * from "./GaussianChart.vue?vue&type=script&lang=js"

import "./GaussianChart.vue?vue&type=style&index=0&id=5f07c2a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f07c2a0"]])

export default __exports__